var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#E6EDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 60C68.84 60 76 52.84 76 44C76 35.16 68.84 28 60 28C51.16 28 44 35.16 44 44C44 52.84 51.16 60 60 60ZM60 68C49.32 68 28 73.36 28 84V92H92V84C92 73.36 70.68 68 60 68Z",
    fill: "#25BCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPicture);
export default __webpack_public_path__ + "static/media/defaultPicture.8d73c71d98ccbbee139e646d25708179.svg";
export { ForwardRef as ReactComponent };